<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('productGroupManage.queryCondition') }}</span>
      </div>
      <div class="">
        <el-form :inline="true" :model="productGroupManageInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-input v-model="productGroupManageInfo.conditions.prodName"
              :placeholder="$t('productGroupManage.selectProductName')" clearable />
          </el-form-item>
          <el-form-item>
            <el-select v-model="productGroupManageInfo.conditions.state"
              :placeholder="$t('productGroupManage.selectStatus')" style="width:100%">
              <el-option label="全部" value="" />
              <el-option :label="$t('productGroupManage.enable')" value="1001" />
              <el-option :label="$t('productGroupManage.disable')" value="2002" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="productGroupManageInfo.conditions.rebateFlag"
              :placeholder="$t('productGroupManage.selectRebate')" style="width:100%">
              <el-option label="全部" value="" />
              <el-option :label="$t('productGroupManage.yes')" value="Y" />
              <el-option :label="$t('productGroupManage.no')" value="N" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_queryProductGroupMethod()">
              {{ $t('productGroupManage.query') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('productGroupManage.groupProducts') }}</span>
        <el-button type="primary" size="small" style="float:right" @click="_openAddProductGroupModal()">
          {{ $t('productGroupManage.add') }}
        </el-button>
      </div>
      <div class="">
        <el-table :data="productGroupManageInfo.productGroups" border style="width:100%">
          <el-table-column prop="groupId" :label="$t('productGroupManage.id')" align="center" />
          <el-table-column :label="$t('productGroupManage.productImage')" align="center">
            <template slot-scope="scope">
              <el-image style="width:50px;height:50px;border-radius:10px"
                :src="scope.row.coverPhoto || '/img/noPhoto.jpg'" fit="cover" />
            </template>
          </el-table-column>
          <el-table-column prop="prodName" :label="$t('productGroupManage.productName')" align="center" />
          <el-table-column prop="userCount" :label="$t('productGroupManage.groupPeople')" align="center" />
          <el-table-column prop="groupPrice" :label="$t('productGroupManage.groupPrice')" align="center">
            <template slot-scope="scope">
              ￥{{ scope.row.groupPrice }}
            </template>
          </el-table-column>
          <el-table-column prop="price" :label="$t('productGroupManage.singlePrice')" align="center">
            <template slot-scope="scope">
              ￥{{ scope.row.price }}
            </template>
          </el-table-column>
          <el-table-column prop="state" :label="$t('productGroupManage.status')" align="center">
            <template slot-scope="scope">
              {{ scope.row.state === '1001' ? $t('productGroupManage.enable') : $t('productGroupManage.disable') }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('productGroupManage.validityPeriod')" align="center">
            <template slot-scope="scope">
              {{ scope.row.startTime }}~{{ scope.row.endTime }}
            </template>
          </el-table-column>
          <el-table-column prop="rebateFlag" :label="$t('productGroupManage.isRebate')" align="center">
            <template slot-scope="scope">
              {{ scope.row.rebateFlag === 'Y' ? $t('productGroupManage.yes') : $t('productGroupManage.no') }}
            </template>
          </el-table-column>
          <el-table-column prop="rebate" :label="$t('productGroupManage.leaderRebate')" align="center">
            <template slot-scope="scope">
              {{ scope.row.rebate }}%
            </template>
          </el-table-column>
          <el-table-column :label="$t('productGroupManage.operation')" align="center" width="180">
            <template slot-scope="scope">
              <el-button size="mini" @click="_openEditProductGroupModel(scope.row)">
                {{ $t('productGroupManage.edit') }}
              </el-button>
              <el-button size="mini" type="danger" @click="_openDeleteProductGroupModel(scope.row)">
                {{ $t('productGroupManage.delete') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination :current-page="productGroupManageInfo.conditions.page"
          :page-size="productGroupManageInfo.conditions.row" :total="productGroupManageInfo.total"
          layout="total, prev, pager, next" @current-change="handleCurrentChange" />
      </div>
    </el-card>

    <add-product-group ref="addProductGroup" @refresh="_listProductGroups" />
    <edit-product-group ref="editProductGroup" @refresh="_listProductGroups" />
    <delete-product-group ref="deleteProductGroup" @refresh="_listProductGroups" />
  </div>
</template>

<script>
import { listProductGroup } from '@/api/group/productGroupApi'
import AddProductGroup from '@/components/group/addProductGroup/addProductGroup'
import EditProductGroup from '@/components/group/editProductGroup/editProductGroup'
import DeleteProductGroup from '@/components/group/deleteProductGroup/deleteProductGroup'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ProductGroupManage',
  components: {
    AddProductGroup,
    EditProductGroup,
    DeleteProductGroup
  },
  data() {
    return {
      productGroupManageInfo: {
        productGroups: [],
        total: 0,
        conditions: {
          prodName: '',
          state: '',
          rebateFlag: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this.productGroupManageInfo.conditions.shopId = getShopId()
    this._listProductGroups()
  },
  methods: {
    async _listProductGroups() {
      try {
        const res = await listProductGroup(this.productGroupManageInfo.conditions)
        this.productGroupManageInfo.productGroups = res.data
        this.productGroupManageInfo.total = res.total
      } catch (error) {
        console.error(error)
      }
    },
    _queryProductGroupMethod() {
      this.productGroupManageInfo.conditions.page = 1
      this._listProductGroups()
    },
    handleCurrentChange(val) {
      this.productGroupManageInfo.conditions.page = val
      this._listProductGroups()
    },
    _openAddProductGroupModal() {
      this.$refs.addProductGroup.open()
    },
    _openEditProductGroupModel(row) {
      this.$refs.editProductGroup.open(row)
    },
    _openDeleteProductGroupModel(row) {
      this.$refs.deleteProductGroup.open(row)
    }
  }
}
</script>

<style scoped>
.card-body {
  padding: 20px;
}
</style>